import React from 'react';

import type { MetadataProps } from './MetadataProps';

export const Metadata: React.FC<MetadataProps> = ({
  title,
  path,
  description,
  isCanonical,
  siteName,
  imgSrc,
  keywords,
  noIndex,
  productMeta,
}) => {
  const metaTitle = (() => {
    const baseTitle = ' - 에이블리';
    if (title.endsWith(' - 에이블리 스토어')) {
      return title.replace(' - 에이블리 스토어', baseTitle);
    }
    return `${title}${baseTitle}`;
  })();

  const href = `https://mobile.a-bly.com${path}`;
  // href에서 qs를 제거한 것. canonical에서 사용
  const cleanHref = `https://mobile.a-bly.com${path.split('?')[0]}`;

  const metaDescription =
    description ||
    '패션부터 뷰티까지, 에이블리 한 곳에서 스타일의 모든 것을 쇼핑하세요!';

  return (
    <>
      <title>{title}</title>
      {isCanonical && <link rel="canonical" href={cleanHref} />}
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover"
      />
      <meta name="title" content={metaTitle} />
      <meta name="description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={href} />
      <meta property="og:title" content={metaTitle} />
      {siteName && <meta property="og:site_name" content={siteName} />}
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={imgSrc} />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={href} />
      <meta property="twitter:title" content={metaTitle} />
      <meta property="twitter:description" content={metaDescription} />
      <meta property="twitter:image" content={imgSrc} />
      {keywords != null && <meta name="keywords" content={keywords} />}
      {noIndex && <meta name="robots" content="noindex" />}
      {productMeta?.brand != null && (
        <meta property="product:brand" content={productMeta.brand} />
      )}
      {productMeta?.availability != null && (
        <meta
          property="product:availability"
          content={productMeta.availability}
        />
      )}
      {productMeta?.condition != null && (
        <meta property="product:condition" content={productMeta.condition} />
      )}
      {productMeta?.priceAmount != null && (
        <meta
          property="product:price:amount"
          content={productMeta.priceAmount}
        />
      )}
      {productMeta?.priceCurrency != null && (
        <meta
          property="product:price:currency"
          content={productMeta.priceCurrency}
        />
      )}
      {productMeta?.retailerItemId != null && (
        <meta
          property="product:retailer_item_id"
          content={productMeta.retailerItemId}
        />
      )}
    </>
  );
};
